// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'FrederickSimms', 'FrederickSimms Fallback', Objektiv, sans-serif"},"className":"__className_130511","variable":"__variable_130511"};